// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__24NhD","Logo":"Toolbar_Logo__3AGXq"};